import { Field, useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { AddressFieldProps } from '../../types/fields';
import { config } from '../../utils/config';
import { Country } from '../../utils/countryData';
import getValidator from '../../utils/getValidator';
import StreetHouseNumberField from '../fields/StreetHouseNumberField';
import TextField from '../formik/TextField';
import StateField from './StateField';
import ZipCodeCityField from './ZipCodeCityField';

const AddressField = (props: AddressFieldProps) => {
  const { values } = useFormikContext<any>();
  const selectedCountry: Country = values[props.context].country;
  const addressFormConfig = config.addressForms[selectedCountry];
  const { formatMessage } = useIntl();

  return (
    <>
      <div className="form__row">
        <StreetHouseNumberField {...props} {...addressFormConfig.streetHouseNumber} country={selectedCountry} />
      </div>
      {addressFormConfig.additional.enabled && (
        <div className="form__row">
          <div className="form__field-container">
            <Field
              name={`${props.context}.additional`}
              component={TextField}
              label={`${formatMessage({ id: 'address.additional' })} (${formatMessage({ id: 'generic.optional' })})`}
              maxLength={addressFormConfig.additional.maxLength}
              validate={getValidator(addressFormConfig.additional)}
              data-test-id={`${props.testIdPrefix}-additional`}
            />
          </div>
        </div>
      )}
      <div className="form__row">
        <ZipCodeCityField {...props} {...addressFormConfig.zipCodeCity} country={selectedCountry} />
      </div>
      {addressFormConfig.state.enabled && (
        <div className="form__row">
          <StateField {...props} {...addressFormConfig.state} country={selectedCountry} />
        </div>
      )}
    </>
  );
};

export default AddressField;
